import { useEffect, useRef, useState } from 'react'
import _ from 'lodash'
import CustomerSearch from '../../../FastQuote/Components/CustomerSearch'
import CustomerAccountSelectModal from './CustomerAccountSelectModal/CustomerAccountSelectModal'

import {
    selectFilteredAccounts,
    LOADING_STATES,
    setAccountFilter,
    setStartedCustomerSearch,
} from '../../../features/customer/customerSlice'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'

interface CustomerSearchTextBoxProps {
    onCustomerChange: (accountCode: string) => void
    value: string
    disabled?: boolean
}

export const CustomerSearchTextBox = (props: CustomerSearchTextBoxProps) => {
    const { onCustomerChange, value, disabled } = props

    const dispatch = useAppDispatch()

    const searchInput = useRef<any>(null)

    const customersLoading = useAppSelector((state) => state.customer.customersLoading)

    const [customerAccountSelectModalOpen, setCustomerAccountSelectModalOpen] =
        useState<boolean>(false)

    useEffect(() => {
        setCustomerAccountSelectModalOpen(customersLoading !== LOADING_STATES.INIT)
    }, [customersLoading])

    return disabled ? (
        <>{value}</>
    ) : (
        <>
            <div>
                <CustomerSearch
                    inputRef={searchInput}
                    onSearch={() => {
                        // clear filter
                        dispatch(setAccountFilter(''))
                        dispatch(setStartedCustomerSearch(true))
                    }}
                    onCustomerChange={onCustomerChange}
                    tooltip='Email, Contact Name, Company Name, Account Code, Quote/Order Number, etc.'
                    placeholder='Customer Search'
                    value={value}
                />
            </div>
            <CustomerAccountSelectModal
                open={customerAccountSelectModalOpen}
                close={() => setCustomerAccountSelectModalOpen(false)}
            />
        </>
    )
}
